const PRODUCT_DATA = [
  {
    id: 0,
    price: 30,
    pricePerUnit: 30,
    qty: 1,
    name: "Caunckz Holiday",
    productDesc: null,
    type: "single",
    bundleName: "1 Pack",
    bundleDesc: "One badass Canuck ready bring holiday cheer whether you like it or not."
  },
  {
    id: 1,
    price: 75,
    pricePerUnit: 25,
    qty: 3,
    name: "Caunckz Holiday",
    productDesc: null,
    type: "three",
    bundleName: "3 Pack",
    bundleDesc: "Three French hens? Try three Holiday Canuckz instead with this festive package of gritty and festive toons!"
  },
  {
    id: 2,
    price: 120,
    pricePerUnit: 24,
    qty: 5,
    name: "Caunckz Holiday",
    productDesc: null,
    type: "five",
    bundleName: "5 Pack",
    bundleDesc: "A chorus of Canuckz! The ultimate package ready to bring extreme holiday cheer to your cardano wallet!"
  }
];

export default PRODUCT_DATA;